import { startAudioPlayerWorklet } from "../utils/audioPlayer.js";
import { startAudioRecorderWorklet } from "../utils/audioRecorder.js";

let audioPlayerNode;
let audioPlayerContext;
let audioRecorderNode;
let audioRecorderContext;
let micStream;
let ws = null;
let isAgentSpeak = false;
let textListeners = new Set();

let is_audio = true;

function emit(evt) {
    textListeners.forEach((fn) => fn(evt));
}

function stopAudioPlayback() {
    if (audioPlayerNode) {
        audioPlayerNode.port.postMessage({ command: "stop" });
        console.log("Audio playback stopped");
    }
}

function sendMessage(message) {
    if (ws && ws.readyState == WebSocket.OPEN) {
        const messageJson = JSON.stringify(message);
        ws.send(messageJson);
    }
}

function arrayBufferToBase64(buffer) {
    let binary = "";
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
}

// Decode Base64 data to Array
function base64ToArray(base64) {
    const binaryString = window.atob(base64);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes.buffer;
}

export function onTextStream(fn) {
    textListeners.add(fn);
    return () => textListeners.delete(fn); // unsubscribe
}

// Audio recorder handler
export function audioRecorderHandler(pcmData) {
    // Send the pcm data as base64
    sendMessage({
        mime_type: "audio/pcm",
        data: arrayBufferToBase64(pcmData),
    });

    // console.log("[CLIENT TO AGENT] sent %s bytes", pcmData.byteLength);
}

export function startAudio(stream) {
    // Start audio output
    startAudioPlayerWorklet().then(([node, ctx]) => {
        audioPlayerNode = node;
        audioPlayerContext = ctx;
    });
    // Start audio input
    startAudioRecorderWorklet(audioRecorderHandler, stream).then(
        ([node, ctx]) => {
            console.log({ node, ctx, stream });
            console.log("mic recorder ready");
            audioRecorderNode = node;
            audioRecorderContext = ctx;
            micStream = stream;
        }
    );
}

export const websocketHandler = (token, userId) => {
    let wsUrl = `ws://localhost:8000/ws/${encodeURIComponent(
        userId
    )}?is_audio=${is_audio}&token=${encodeURIComponent(token)}`;

    if (token && userId) {
        ws = new WebSocket(wsUrl);
    }

    ws.onopen = function () {
        // Connection opened messages
        console.log("WebSocket connection opened successfully!");
    };

    ws.onmessage = function (event) {
        const message_from_server = JSON.parse(event.data);

        // Check if the turn is complete
        // if turn complete, add new message
        if (
            message_from_server.turn_complete &&
            message_from_server.turn_complete == true
        ) {
            isAgentSpeak = false;
            emit({ type: "done" });
            return;
        }

        // Check if the turn was interrupted
        if (
            message_from_server.interrupted &&
            message_from_server.interrupted == true
        ) {
            isAgentSpeak = false;
            stopAudioPlayback();
            emit({ type: "interrupted" });
            return;
        }

        // If it's audio, play it
        if (message_from_server.mime_type == "audio/pcm" && audioPlayerNode) {
            isAgentSpeak = true;
            audioPlayerNode.port.postMessage(
                base64ToArray(message_from_server.data)
            );
        }

        // If it's a text, print it
        if (message_from_server.mime_type == "text/plain") {
            emit({ type: "partial", text: message_from_server.data ?? "" });
        }
    };

    ws.onclose = (event) => {
        console.log("❌ WebSocket closed", event);
    };

    ws.onerror = (err) => {
        console.error("⚠️ WebSocket error:", err);
    };
};

export function closeWS() {
    if (ws && ws.readyState === WebSocket.OPEN) {
        ws.close(1000, "User manually closed connection"); // 1000 = normal close
        console.log("🔌 WS connection closed manually");
    } else {
        console.log("⚠️ No active WS connection to close");
    }

    if (micStream) {
        micStream.getTracks().forEach((track) => track.stop());
        // console.log("🎤 Microphone stopped");
        micStream = null;
    }
}

export function handleInterrupt() {
    if (isAgentSpeak && ws && ws.readyState === WebSocket.OPEN) {
        if (is_audio && audioPlayerNode) {
            audioPlayerNode.port.postMessage({ command: "stop" });
            // console.log("mantap");
        }
        if (is_audio) {
            sendMessage({
                mime_type: "interrupt",
                data: "user_interrupt",
            });
        }
    }
}

export function agentSpeakStatus() {
    return isAgentSpeak;
}
